module.exports = __webpack_public_path__ + "img/Strike-STRK.c062476b.svg";